import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';
import { CommandOpeningTime } from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'LocksCommandSettings',
})
export default class LocksCommandSettings extends DeviceSettingsComponent {
  CommandOpeningTime = CommandOpeningTime;

  get settings() {
    return this.defaultSettings.lockCommandSettings;
  }
}
